import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'how_are_wrkrs_paid_select_all_that_apply'

export const dataPointDefinition = {
  retracedId: 'how_are_wrkrs_paid_select_all_that_apply',
  name: 'How are workers paid?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'CASH',
      text: 'Cash',
      externalIds: [
        {
          id: 'wb-15-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'NUMBER',
        text: 'What approximate percentage of workers are paid by cash?',
        externalIds: [
          {
            id: 'wb-15-1f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'CHECK',
      text: 'Check',
      externalIds: [
        {
          id: 'wb-15-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'NUMBER',
        text: 'What approximate percentage of workers are paid by check?',
        externalIds: [
          {
            id: 'wb-15-2f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'DIRECT_DEPOSIT_INTO_A_BANK_ACCOUNT',
      text: 'Direct deposit into a bank account',
      externalIds: [
        {
          id: 'wb-15-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'NUMBER',
        text: 'What approximate percentage of workers are paid by direct deposit into bank accounts?',
        externalIds: [
          {
            id: 'wb-15-3f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'MOBILE_MONEY',
      text: 'Mobile money',
      externalIds: [
        {
          id: 'wb-15-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'NUMBER',
        text: 'What approximate percentage of workers are paid by mobile money?',
        externalIds: [
          {
            id: 'wb-15-4f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'CARD_WITH_A_STORED_VALUE_',
      text: 'Card (with a stored value)',
      externalIds: [
        {
          id: 'wb-15-5x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'NUMBER',
        text: 'What approximate percentage of workers are paid by card (with a stored value)?',
        externalIds: [
          {
            id: 'wb-15-5f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'wb-15-6x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'wb-15-6f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'CASH',
                'CHECK',
                'DIRECT_DEPOSIT_INTO_A_BANK_ACCOUNT',
                'MOBILE_MONEY',
                'CARD_WITH_A_STORED_VALUE_',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: ['string', 'number'],
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-wag-44',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 8520,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
